// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = props =>
  makeStyles(theme => ({
    palette: {
      width: '100%',
    },
    divider: {
      margin: theme.spacing(2, 0),
    },
    textColor: {
      textAlign: 'left',
      fontWeight: 600,
      fontSize: 14,
      color: colors.grey900,
    },
    rectangle: {
      width: '100%',
      padding: theme.spacing(1, 1.5),
      margin: theme.spacing(1, 0),
      borderRadius: 4,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    rectangleFirstText: {
      fontSize: '14px',
      fontWeight: 500,
      marginRight: theme.spacing(2),
    },
    rectangleSecondText: {
      fontWeight: 500,
      fontSize: '12px',
    },
    primaryRectangle: {
      color: '#FFFFFF',
      backgroundColor:
        props && props.primaryColor ? props.primaryColor : 'transparent',
    },
    secondaryRectangle: {
      color: colors.grey900,
      backgroundColor:
        props && props.secondaryColor ? props.secondaryColor : 'transparent',
    },
  }));

type Props = {
  primaryColor: string,
  secondaryColor: string,
};

export default function ColorPalette(props: Props) {
  const {primaryColor, secondaryColor} = props;
  const classes = useStyles({primaryColor, secondaryColor})();
  return (
    <div className={classes.palette}>
      <Typography className={classes.textColor}>Color primario</Typography>
      <div className={`${classes.rectangle} ${classes.primaryRectangle}`}>
        <Typography className={classes.rectangleFirstText}>Aa</Typography>
        <Typography className={classes.rectangleSecondText}>
          Color de texto
        </Typography>
      </div>
      <Divider className={classes.divider} />
      <Typography className={classes.textColor}>Color secundario</Typography>
      <div className={`${classes.rectangle} ${classes.secondaryRectangle}`}>
        <Typography className={classes.rectangleFirstText}>Aa</Typography>
        <Typography className={classes.rectangleSecondText}>
          Color de texto
        </Typography>
      </div>
    </div>
  );
}

ColorPalette.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
};
